import { render } from "./android.svg?vue&type=template&id=4a80d3de"
const script = {}
script.render = render

export default script